import React from 'react'
import { Trans, withI18nContext } from '@mc/i18n'
import { useCertsAddOnPriceLimit } from '../../hooks/useCertsAddOnPriceLimit'
import { CERTS_QUIZ_PLANS_I18N_NAMESPACE, i18nInstance } from '../../i18n'

const t = i18nInstance.getFixedT(null, CERTS_QUIZ_PLANS_I18N_NAMESPACE)

const UTM_PARAMS =
  'utm_source=checkout&utm_medium=faq&utm_campaign=prcng-1138_v1'

const ELIGIBLE_CERTIFICATES = [
  { key: 'navySeal', slug: 'leadership-and-decision-making-under-pressure' },
  {
    key: 'moonshot',
    slug: 'breakthrough-innovation-strategy-from-bold-idea-to-business-impact',
  },
  {
    key: 'aiFundamentals',
    slug: 'ai-fundamentals-think-create-and-work-smarter',
  },
  {
    key: 'leadWithAi',
    slug: 'lead-with-ai-adapt-implement-transform-your-organization',
  },
  { key: 'negotiateToWin', slug: 'negotiate-to-win-essentials-for-leaders' },
  {
    key: 'strategicCommunication',
    slug: 'strategic-communication-build-trust-drive-decisions-lead-with-influence',
  },
] as const

const CertificatesList = () => (
  <ul className='list-styled mc-mx-4 mc-px-4'>
    {ELIGIBLE_CERTIFICATES.map(({ key, slug }) => (
      <li key={key}>
        <a
          href={`/certificates/${slug}?${UTM_PARAMS}&utm_content=${key}`}
          target='_blank'
          rel='noopener noreferrer'
          className='mc-text--link'
        >
          {t(`faq.certificatesList.${key}`)}
        </a>
      </li>
    ))}
  </ul>
)

const AnswerComponent = withI18nContext(i18nInstance)(() => {
  const maxPrice = useCertsAddOnPriceLimit()

  return (
    <p className='mc-opacity--hinted'>
      <Trans
        i18nKey={'faq.answer'}
        ns={CERTS_QUIZ_PLANS_I18N_NAMESPACE}
        values={{ maxPrice }}
        components={{
          p: <p />,
          separator: <span className='mc-mb-5 d-block' />,
          certificatesList: <CertificatesList />,
        }}
      />
    </p>
  )
})

export const FAQ_UUID = 'How Does The Certificates Add-On Work'

export const certsAddOnFAQ = ({ hide = true }: { hide?: boolean } = {}) => [
  {
    uuid: FAQ_UUID,
    title: t(`${CERTS_QUIZ_PLANS_I18N_NAMESPACE}:faq.question`),
    answer: <AnswerComponent />,
    hide,
  },
]
